import { useContext, useEffect, useState } from 'react';
import { Box } from '../../shared/layouts';
import { useTranslation } from 'react-i18next';
import UserContext, { AUTH_STATUS } from '../../../context/UserContext';
import LoginContainer from './LoginContainer';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import Button from '../../shared/Button';
import axios from 'axios';
import Loader from '../../shared/Loader';
import { useNavigate } from 'react-router-dom';
import RadioButton from "../../shared/RadioButton";

const DossierSelectPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { multipleDossiers } = useContext(WhiteLabelContext);
  const { logoutUser, authStatus, setUser, initPathname, linkedDossiers } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [sessionDossier, setSessionDossier] = useState(null);

  useEffect(() => {
    if (authStatus === AUTH_STATUS.loggedin && !multipleDossiers) {
      navigate('/dashboard');
    }
  }, [authStatus, multipleDossiers]);

  // Auto-select first option
  useEffect(() => {
    if (!sessionDossier && linkedDossiers[0]) {
      setSessionDossier(linkedDossiers[0].value)
    }
  }, [linkedDossiers]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios.post('/set-session', {
      'dossier': sessionDossier
    }).then((res) => {
      const dossier = res.data.dossier;

      setUser(user => ({ ...user, dossier }));
      navigate(initPathname ? initPathname : '/dashboard');
    }).catch((err) => {
      setLoading(false);
      if (err.response.status !== 422) {
        setErrors({
          dossier: [t('Geselecteerde dossier is niet beschikbaar')]
        });
      } else {
        setErrors(err.response.data.errors);
      }
    });
  }

  if (authStatus === AUTH_STATUS.loading) {
    return <Loader />;
  }

  return (
    <>
      <LoginContainer handleSubmit={handleSubmit}>
        <Box fontScale="2xl" fontWeight="bold">
          {t('Welk dossier wil je gebruiken?')}
        </Box>

        <RadioButton
          name="dossier"
          value={sessionDossier}
          onChange={(value) => setSessionDossier(value)}
          options={linkedDossiers}
          errors={errors?.dossier}
        />

        <Button
          disabled={!sessionDossier || loading}
          variant="primary"
          width="100%"
          type="submit"
        >
          {t('Bevestigen')}
        </Button>

        <Button
          width="100%"
          variant="primary-outline"
          onClick={() => {
            logoutUser();
          }}
          disabled={loading}
        >
          {t('Uitloggen')}
        </Button>
      </LoginContainer>
    </>
  );
};

export default DossierSelectPage;
